// LoadingContext.js
import React, { createContext, useState, useContext } from 'react';

// Create the Loading Context
const LoadingContext = createContext();

// LoadingProvider component that wraps your app and provides loading state
export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

// Custom hook to access loading state and setLoading function
export const useLoading = () => useContext(LoadingContext);
